module.exports = __webpack_public_path__ + "static/art3-966b5636976098db8aa6d2b9fd806e2b.png";